<template>
  <div>
    <div class="h-100 pl-2 pr-2 pt-2 pb-2">
      <div
        style="
          position: fixed;
          top: 20px;
          left: 0;
          z-index: 1;
          backdrop-filter: blur(2px);
        "
        v-if="LoaderStatus || loader"
      >
        <Spinner />
      </div>

      <div>
        <div
          id="scrollToTop"
          class="mt-2 newInt-full-container"
          @scroll="onScroll"
        >
          <template
            v-if="
              feedbackform.length == 0 &&
              searchQuery == '' &&
              LoaderStatus == false &&
              ($route.query.type == '1' || $route.query.type == '2')
            "
          >
            <div
              class="
                d-flex
                flex-column
                align-items-center
                justify-content-center
              "
              style="height: calc(100vh - 304px)"
            >
              <div>
                <img
                  src="../../assets/New-imgs/interviewProcess-icons/newInt-noData.svg"
                  alt=""
                />
              </div>
              <div class="teams-empty-container-font">
                There is no feedback form created, <br />
                click <strong> "+ Feedback Form" </strong>
                button to create
              </div>
            </div>
          </template>
          <template
            v-else-if="
              $route.query.type == '0' &&
              page == 0 &&
              feedbackform.length == 0 &&
              searchQuery == '' &&
              LoaderStatus == false
            "
          >
            <div
              class="
                d-flex
                flex-column
                align-items-center
                justify-content-center
              "
              style="height: calc(100vh - 304px)"
            >
              <div>
                <img
                  src="../../assets/New-imgs/interviewProcess-icons/inactive-int.svg"
                  alt=""
                />
              </div>
              <div class="teams-empty-container-font">
                There are no inactive feedback form
              </div>
            </div>
          </template>
          <template v-if="feedbackform.length == 0">
            <div
              class="
                d-flex
                flex-column
                align-items-center
                justify-content-center
              "
              style="height: calc(100vh - 304px)"
            >
              <div
                class="
                  d-flex
                  flex-column
                  align-items-center
                  justify-content-center
                  h-100
                "
                v-if="
                  !LoaderStatus && feedbackform.length == 0 && searchQuery != ''
                "
              >
                <div>
                  <img
                    src="../../assets/img/accessconnew/emptyprivilageBig.svg"
                    alt=""
                  />
                </div>
                <div
                  v-if="searchQuery != 'Loader' && searchQuery != ''"
                  class="mt-2 text-center access-font-color"
                >
                  No matching results for
                  <span class="access-font-color-b text-center text-break">
                    "{{ searchQuery }}"
                  </span>
                </div>
              </div>
            </div>
          </template>
          <template v-else-if="feedbackform.length > 0">
            <div class="d-flex flex-wrap gap-15 mt-1 ml-1">
              <!-- for active use previewfdbckmaincard-active this class -->
              <div
                class="previewfdbckmaincard relativeclass"
                :class="
                  preview != i.feedbackFormID && toggleIcon != i.feedbackFormID
                    ? 'previewfdbckmaincard'
                    : 'previewfdbckmaincard-active'
                "
                v-for="(i, index1) in feedbackform"
                :key="index1"
                :id="i.feedbackFormID"
              >
                <div
                  class="
                    tp-cardhead
                    d-flex
                    align-items-center
                    position-relative
                  "
                  style="height: 15%"
                >
                  <div
                    class="relativeclass"
                    style="width: 65%"
                    :style="
                      i.active || !roles.includes('CLONE_FEEDBACK_FORM')
                        ? 'width: 75%'
                        : 'width: 65%'
                    "
                  >
                    <div class="text-truncate d-flex align-items-center mr-2">
                      <span class="mb-1">
                        <img
                          src="../../assets/img/feedbackform/fdbckfirst.svg"
                          alt=""
                        />
                      </span>
                      <span
                        v-b-tooltip.hover.bottom="i.name"
                        class="
                          pff-card-heading
                          d-inline-block
                          text-truncate
                          ml-2
                          mb-1
                        "
                        style="max-width: 100%"
                      >
                        {{ i.name }}</span
                      >
                    </div>
                  </div>
                  <div
                    class="
                      pff-action-icon-container
                      pointer
                      d-flex
                      align-items-center
                    "
                    v-if="toggleIcon === i.feedbackFormID"
                  >
                    <img
                      v-b-tooltip.hover.top="'Clone'"
                      v-if="roles.includes('CLONE_FEEDBACK_FORM')"
                      class="ml-2 newIcons-expand"
                      src="../../assets/img/feedbackform/Duplicate.svg"
                      @click.stop="(cloneModal = true), cloningModal(i)"
                      alt=""
                    />
                    <img
                      v-if="roles.includes('PUT_FEEDBACK_FORM')"
                      v-b-tooltip.hover.top="'Edit'"
                      @click="updatefdbckform(i, false)"
                      class="ml-2 newIcons-expand"
                      src="../../assets/img/feedbackform/edit.svg"
                      alt=""
                    />
                    <img
                      v-if="roles.includes('DELETE_FEEDBACK_FORM')"
                      v-b-tooltip.hover.top="'Delete'"
                      class="ml-2 newIcons-expand"
                      src="../../assets/img/feedbackform/delete.svg"
                      alt=""
                      @click="
                        $bvModal.show('deleteIntModal'), deleteFeedback(i)
                      "
                    />
                    <img
                      class="ml-2 newIcons-expand"
                      src="../../assets/img/feedbackform/cancel.svg"
                      alt=""
                      @click="hideFeedbackdetail()"
                    />
                  </div>
                  <div class="pointer d-flex" style="width: 25%" v-else>
                    <div
                      v-if="roles.includes('CLONE_FEEDBACK_FORM') && !i.active"
                      @click="(cloneModal = true), cloninginactiveModal(i)"
                      class="mr-2 newIcons-hover"
                      v-b-tooltip.hover.top="'Clone'"
                    >
                      <img
                        src="../../assets/New-imgs/interviewProcess-icons/inactive-clone.svg"
                        alt=""
                      />
                    </div>

                    <div
                      class="mr-2"
                      v-if="!i.active"
                      @click="updatefdbckform(i, true)"
                    >
                      <img
                        class="imageshover"
                        v-b-popover.hover.top="'Activate'"
                        src="../../assets/img/feedbackform/activate2.svg"
                        alt=""
                      />
                    </div>
                    <div class="mr-2" v-if="preview != i.feedbackFormID">
                      <img
                        @click.stop="particularFeedbackdetail(i)"
                        class="imageshover"
                        v-b-popover.hover.top="'View'"
                        src="../../assets/New-imgs/interviewProcess-icons/newInt-eyeicon.svg"
                        alt=""
                      />
                    </div>
                    <div
                      class="mr-2"
                      v-else
                      @click.stop="(preview = ''), (showviewcontainer = false)"
                    >
                      <img
                        @click="hideFeedbackdetail()"
                        class="imageshover"
                        v-b-popover.hover.top="'Hide'"
                        src="../../assets/New-imgs/interviewProcess-icons/newInt-notview-icon.svg"
                        alt=""
                      />
                    </div>
                    <div
                      class="pff-card-icon-container"
                      v-if="
                        i.active &&
                        (roles.includes('DELETE_FEEDBACK_FORM') ||
                          roles.includes('CLONE_FEEDBACK_FORM') ||
                          roles.includes('PUT_FEEDBACK_FORM'))
                      "
                      @click="toggleValue(i)"
                    >
                      <img
                        src="../../assets//img/feedbackform/moreinfo.svg"
                        alt=""
                      />
                    </div>

                    <div
                      v-if="i.active && roles.includes('DELETE_FEEDBACK_FORM')"
                      class="mr-2 pointer"
                      v-b-modal.deleteModal
                      @click="delFeedbackform(i)"
                    ></div>
                  </div>
                </div>
                <div class="pff-card-skilltxt mt-2">Skills</div>
                <div v-if="i.skills">
                  <div
                    class="pfdbck-skillcards"
                    v-for="(input, index) in i.skills.slice(0, 2)"
                    :key="index"
                  >
                    <div class="d-flex">
                      <div class="pfdbckskillname text-truncate">
                        {{ input.name | fdbckFilter }}&nbsp;
                      </div>
                      <div
                        v-if="input.markingType == 'score'"
                        class="pfdbckscore"
                      >
                        / Score
                      </div>
                      <div
                        v-if="input.markingType == 'rating'"
                        class="pfdbckrating"
                      >
                        / Rating
                      </div>
                      <div
                        v-if="input.commentMode == true"
                        class="pfdbckcomments"
                      >
                        &nbsp; / Comments
                      </div>
                    </div>
                  </div>
                </div>
                <div class="inactive-text-box-pfbk" v-if="!i.active">
                  <div class="inactive-txt">Inactive</div>
                </div>
                <div
                  class="
                    w-100
                    d-flex
                    justify-content-end
                    align-items-center
                    pff-bottom-content
                  "
                >
                  <!-- <div :class="{ 'inc-bottom': !i.active }">
                    <div
                      v-if="i.screenshot == true"
                      class="d-flex align-items-center"
                    >
                      <img src="../../assets/img/feedbackform/ss.svg" alt="" />
                      <div class="pff-ss-txt ml-1">Screenshot Required</div>
                    </div>
                    <div
                      v-if="i.screenshot == false"
                      class="d-flex align-items-center"
                    >
                      <img src="../../assets/img/feedbackform/ss.svg" alt="" />
                      <div class="pff-ss-txt ml-1">Screenshot Not Required</div>
                    </div>
                  </div> -->

                  <div
                    class="pff-card-morefields-txt"
                    v-if="i.skills && i.skills.length > 2"
                  >
                    <div
                      class="mr-3 pointer"
                      @click.stop="particularFeedbackdetail(i)"
                    >
                      <div :class="{ margin: !i.active }">
                        + {{ i.skills.length - 2 }}
                        <span v-if="i.skills.length - 2 == 1"> more field</span>
                        <span v-else> more fields</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              style="margin: auto"
              class="d-flex justify-content-center mb-3"
              v-if="showLoader"
            >
              <b-spinner label="Loading..."></b-spinner>
            </div>
          </template>
        </div>
      </div>
      <deleteModal
        v-if="$route.query.status === 'feedbackForm'"
        :deletefeedbackforms="deletefeedbackforms"
        @resetPagination="resetPagination"
      />
      <CloneModal
        v-if="$route.query.status === 'feedbackForm' && cloneModal"
        :cloneModal="cloneModal"
        :cloningData="cloningData"
        header="Clone FeedbackForm Process"
        subHeader="New Feedback Form Name"
        :duplicatecloneName="duplicatecloneName"
        placeholder="Enter Feedback Form Name"
        errorMessage="Feedback Form Name already exists"
        :cloningName="cloningName"
        @resetPagination="resetPagination"
        @handle-clone="cloneFeedback"
        @closeCloneModal="closeCloneModal"
        @change-duplicate-name="duplicatecloneName = false"
        :buttonLoader="buttonLoader"
        buttonName="Clone"
      />
    </div>
  </div>
</template>
<script>
import {
  getFeedbackFormSort,
  deletefeedbackform,
  addfeedbackform,
} from "../../utils/apiFunctions.js";
import { mapGetters } from "vuex";
import { required, maxLength } from "vuelidate/lib/validators";

import toast from "../../components/mixin/toast";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import deleteModal from "../../views/InterviewProcess/deleteModal.vue";
import CloneModal from "../../views/InterviewProcess/cloneModal.vue";

export default {
  name: "PreviewFeedbackForm",

  props: {
    interviewType: String,
    sortOrder: String,
    sortColumn: String,
    sort_selected: String,
  },

  mixins: [toast],
  components: {
    Spinner,
    deleteModal,
    CloneModal,
  },
  data() {
    return {
      toggleIcon: "",
      loader: false,
      buttonLoader: false,
      cloneModal: false,
      deletefeedbackforms: {},
      duplicatecloneName: false,
      cloningName: "",
      cloningData: {},
      type: 1,
      ratingvalue: 0,
      count: 30,
      page: 0,
      showsortcard: false,
      showviewcontainer: false,
      LoaderStatus: false,
      showtypecard: false,
      showLoader: false,
      pageEnd: null,
      total: null,
      preview: "",

      feedbacktype: "Active",
      feedbackform: [],
      delfeedback: [],
      singleFeedbackform: {},
      recommendations: [
        {
          value: true,
          name: "Yes",
        },
        {
          value: false,
          name: "No",
        },
      ],
      options: [
        { value: "rating", name: "Rating" },
        { value: "score", name: "Score" },
      ],
      Screenshots: [
        { value: "yes", name: "Yes" },
        { value: "no", name: "No" },
      ],
      sort_options: [
        { text: "Name(Asce)", value: "1" },
        { text: "Name(Desc)", value: "2" },
        { text: "Date Created(Asce)", value: "3" },
        { text: "Date Created(Desc)", value: "4" },
        { text: "Date Modified(Asce)", value: "5" },
        { text: "Date Modified(Desc)(Default)", value: "6" },
      ],
      feedbacktypeoptions: [
        { text: "All", value: "2" },
        { text: "Active", value: "1" },
        { text: "Inactive", value: "0" },
      ],
      feedbackToDelete: null,
    };
  },
  filters: {
    formatDate(dateStr) {
      const date = new Date(dateStr);
      const day = ("0" + date.getDate()).slice(-2);
      const month = ("0" + (date.getMonth() + 1)).slice(-2);
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    },
  },
  computed: {
    ...mapGetters(["roles"]),
    ...mapGetters("searchVUEX", {
      searchQuery: "getSearchQuery",
    }),
  },
  validations() {
    return {
      cloningName: {
        required,
        maxLength: maxLength(128),
      },
    };
  },
  watch: {
    searchQuery(newValue, oldValue) {
      if (newValue != oldValue) {
        if (newValue != "Loader") {
          this.resetPagination();
        }
      }
    },
  },

  created() {
    this.resetPagination();
  },
  methods: {
    toggleValue(data) {
      this.singleFeedbackform = data;
      if (this.preview != "") {
        this.$emit("singleFeedbackForm", this.singleFeedbackform);
      } else {
        this.$emit("singleFeedbackForm", {});
      }
      this.toggleIcon = data.feedbackFormID;
      this.preview = "";
    },
    closeCloneModal() {
      this.cloneModal = false;
    },
    cloninginactiveModal(i) {
      this.cloningData = i;
      this.$v.$reset();
      this.duplicatecloneName = false;
    },
    cloningModal(i) {
      this.cloningData = i;

      this.$v.$reset();
      this.duplicatecloneName = false;
    },
    resetFeedback() {
      this.deletefeedbackforms = {};
    },
    // Managing tab redirect based on Feedback type and Sort
    tabRedirect() {
      if (this.$route.query.sort || this.$route.query.type) {
        this.sort_selected = this.$route.query.sort;
        this.feedbacktype = this.$route.query.type;
        this.saveSort();
        return;
      }
      this.resetPagination();
    },
    updatefdbckform(feedbackForm, val) {
      if (!val) {
        this.$router.push({
          path: `/hiringprocess/editfeedbackform/${feedbackForm.feedbackFormID}/${this.$route.query.type}`,
          query: {
            status: this.$route.query.status,
            type: this.$route.query.type,
            sort: this.$route.query.sort,
          },
        });
      } else if (val) {
        this.$router.push({
          path: `/hiringprocess/activatefeedbackform/${feedbackForm.feedbackFormID}/${this.$route.query.type}`,
          query: {
            type: this.$route.query.type,
            sort: this.$route.query.sort,
            status: this.$route.query.status,
          },
        });
      }
    },

    deleteFeedback(data) {
      this.deletefeedbackforms = data;
    },
    async deleteparticularfdbck(delfdbck) {
      this.$bvModal.hide("feedbackdeleteModal");
      try {
        let payload = {
          feedbackFormID: delfdbck.feedbackFormID,
        };
        const res = await deletefeedbackform(payload);
        if (res.status == 200) {
          this.showviewcontainer = false;
          this.successModal("Feedback form deleted successfully!");
          this.resetPagination();
        } else if (res.status == 409) {
          let errorMessage = res.data.data.Details;
          this.errorModal(`${errorMessage}`);
        }
      } catch (error) {
        if (error.response.status == 409) {
          let errorMessage = error.response.data.data.Details;
          this.errorModal(`${errorMessage}`);
        } else {
          this.errorModal("Something went wrong!");
          throw new Error(`Failed! status:${error.status}`);
        }
      }
    },
    closeDeleteModal() {
      this.$bvModal.hide("deleteModal");
    },
    particularFeedbackdetail(details) {
      this.singleFeedbackform = details;
      this.scrollToForm(details.feedbackFormID);
      this.$emit("singleFeedbackForm", this.singleFeedbackform);
      this.preview = details.feedbackFormID;
      this.showviewcontainer = true;
      this.toggleIcon = "";
    },
    hideFeedbackdetail() {
      this.$emit("singleFeedbackForm", {});
      this.toggleIcon = "";
    },
    scrollToForm(id) {
      this.$nextTick(() => {
        document.getElementById(id).scrollIntoView({
          block: "nearest",
        });
      });
    },

    goToCreateInterviewForm() {
      this.$router.push({
        path: "/previewfeedbackform/feedbackform",
        query: {
          status: "previewfeedback",
          redirect: this.$route.name,
          type: this.feedbacktype,
          sort: this.sort_selected,
        },
      });
    },
    hidefeedbackoptions() {
      this.showtypecard = false;
    },
    hidesortoptions() {
      this.showsortcard = false;
    },
    getFeedbackValue(value) {
      this.LoaderStatus = true;
      this.type = value;
      this.showtypecard = false;
      this.preview = "";
      this.showviewcontainer = false;
      this.preview = "";
      this.resetPagination();
    },
    resetPagination() {
      this.toggleIcon = "";
      this.page = 0;
      this.feedbackform = [];
      this.showLoader = false;
      this.loader = true;
      this.LoaderStatus = true;
      this.$emit("singleFeedbackForm", {});
      this.getallfeedbackforms();
    },
    onScroll(e) {
      // Get the target element of the scroll event.
      const { target } = e;
      // Check if the user has reached the bottom of the scrollable area.
      if (
        Math.ceil(target.scrollTop) >=
        target.scrollHeight - target.offsetHeight - 2
      ) {
        // Check if there is more data to load.
        if (this.checkbetween(this.pageEnd, 0, this.total)) {
          this.page++;
          this.getallfeedbackforms();
        }
      }
    },
    checkbetween(x, min, max) {
      // Return `true` if `x` is between `min` and `max`, otherwise `false`.
      return x > min && x < max;
    },
    async getallfeedbackforms() {
      let payload = {
        searchQuery: this.searchQuery,
        order: this.sortOrder,
        sortBy: this.sortColumn,
        type: this.$route.query.type,

        page: this.page,
        count: this.count,
      };
      const response = await getFeedbackFormSort(payload);
      if (response.status == 200) {
        if (this.page == 0) {
          this.feedbackform = response.data.data.data;
        } else {
          this.feedbackform = [
            ...this.feedbackform,
            ...response.data.data.data,
          ];
        }
        this.total = response.data.data.total;
        this.pageEnd = response.data.data.pageEnd;
        if (response.data.data.total === response.data.data.pageEnd) {
          this.showLoader = false;
        } else {
          this.showLoader = true;
        }
        this.LoaderStatus = false;
      } else {
        this.LoaderStatus = false;
      }
      this.loader = false;
      this.preview = "";
      this.toggleIcon = "";
      this.$emit("update-feedbackform-length", this.feedbackform.length);
    },
    async cloneFeedback(cloningName) {
      try {
        this.buttonLoader = true;
        let clonedData = { ...this.cloningData };
        delete clonedData.basicInfo;
        delete clonedData.active;
        delete clonedData.createdAt;
        delete clonedData.createdBy;
        delete clonedData.feedbackFormID;
        delete clonedData.lowerName;
        delete clonedData.licenseKey;
        delete clonedData.recommendationComments;
        delete clonedData.taggedInterviewProcess;
        delete clonedData.screenshotMedia;
        clonedData.name = cloningName;
        const response = await addfeedbackform(clonedData);
        if (response.status == 200) {
          this.successModal("Feedback Form cloned successfully!");
          this.cloningName = "";
          this.cloneModal = false;
          this.buttonLoader = false;
          this.resetPagination();
        } else if (response.status == 409) {
          this.duplicatecloneName = true;
          this.buttonLoader = false;
        }
      } catch (error) {
        this.duplicatecloneName = false;
        this.buttonLoader = false;

        throw new Error(`Failed! status:${error.status}`);
      }
    },
  },
};
</script>

<style>
.activate-txt {
  color: #038e00;
  text-decoration: underline;
}

.z-10 {
  z-index: 10;
}

.tnt-sortcard .custom-control {
  padding-left: 2rem;
  padding-top: 5px;
  padding-bottom: 5px;
}

.sort-radio:nth-child(even) {
  background: #fdfdfd;
}

.sort-radio:nth-child(odd) {
  background: #f4f4f4;
}

.sstextposition {
  position: absolute;
  bottom: 5px;
}

.sspresent-text {
  font-weight: 400;
  font-size: 11px;
  color: #87ae85;
}

.fieldtextposition {
  position: absolute;
  bottom: 4px;
  right: 10px;
}

.ssnotpresent-text {
  font-weight: 400;
  font-size: 11px;
  color: #b8b9c7;
}

.feedback-right-container {
  border-radius: 8px;
}

.preview-head-text {
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
  color: #696969;
}

.fdbck-recodn-container {
  background: #ffffff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-radius: 0px 0px 4px 4px;
  padding: 25px;
}

.interskilkls-head {
  font-weight: 600;
  font-size: 13px;
  color: #72738e;
  word-break: break-all;
}

.interskills-container {
  background: #ffffff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  padding: 10px;
}

.fdbck-right-head-container {
  padding: 10px 15px;
  font-weight: 600;
  font-size: 14px;
  color: #ffffff;
  margin: 5px;
  background: rgba(10, 86, 200, 0.5);
  border-radius: 2px;
}

.fdbck-right-detail-container {
  background: #ffffff;
  border: 0.7px solid #e5e5e5;
  box-sizing: border-box;
  box-shadow: 0px 1px 20px rgba(86, 86, 86, 0.2);
  border-radius: 5px;
  height: calc(100vh - 195px);
  overflow: auto;
  margin: 5px 0px;
}

.preview-feedbackform-main-card {
  background: #fbfbfb;
  border: 0.5px solid #e5e5e5;
  box-sizing: border-box;
  box-shadow: 0px 0px 20px rgba(86, 86, 86, 0.2);
  border-radius: 5px;
  padding: 10px;
  width: 300px;
  margin: 15px;
  height: calc(90vh - 140px);
  overflow: auto;
  position: relative;
}

.preview-feedbackform-header h5 {
  font-weight: 600;
  font-size: 14px !important;
  color: #696969;
  padding: 15px;
  padding-bottom: 0;
}

.b-rating.disabled {
  background-color: unset;
}

.ssbox {
  background: #fdfdfd;
  border: 0.3px solid rgba(10, 86, 200, 0.5);
  box-sizing: border-box;
  box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-radius: 1px;

  height: 87px;
}

.give-text {
  margin-left: 3px;
  font-weight: 600;
  font-size: 12px;
  line-height: 9px;
  /* identical to box height */

  color: #535461;
}

.not-add {
  font-weight: normal;
  font-size: 5px;
  line-height: 7px;

  color: #72738e;
}

.add-notepreview {
  font-weight: normal;
  font-size: 10px;
  line-height: 7px;
  /* identical to box height */
  margin-top: 14px;

  color: #72738e;
}

.hov {
  width: 100px;
  height: 30px;
  background: rgba(255, 0, 0, 0.5) !important;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.18);
  border-radius: 6px;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
  border: unset;
  line-height: 15px;
}

.button-previewcust {
  position: absolute;
  top: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  left: 0;
  z-index: 1;
  height: 100%;
  width: 100%;
  visibility: hidden;

  background: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(4px);
}

.preview-feedbackform-main-card:hover .button-previewcust {
  visibility: visible;
}

.hov-two {
  top: 10px;
  width: 100px;
  height: 30px;
  background: rgba(10, 86, 200, 0.5) !important;
  border-radius: 6px;
  border: unset;
  font-weight: 500;
  margin-top: 20px;
  font-size: 14px;
  line-height: 15px;
  color: #ffffff;
}

.basic-txt {
  margin-bottom: 10px;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;

  color: #696969;
}

.preview-feedbackform-main-card.cards-form {
  background: #fbfbfb;
  border: 0.5px solid #e5e5e5;
  box-sizing: border-box;
  box-shadow: 0px 0px 20px rgb(86 86 86 / 20%);
  border-radius: 5px;
  padding: 10px;
  width: unset;
  margin: 15px;
  height: calc(90vh - 50px);
  overflow: auto;
}

.overflow-hide:hover {
  overflow: hidden;
}
.previewfeedback-headingbox {
  padding: 10px 15px;
  font-weight: 600;
  font-size: 14px;
  color: #72738e;
  background: #cbccdd;
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.14);
  border-radius: 4px 4px 0px 0px;
}

.ssbox.hover-new {
  background: #fdfdfd;
  border: 0.3px solid rgba(10, 86, 200, 0.5);
  box-sizing: border-box;
  box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-radius: 1px;

  height: 87px;
}
</style>
